import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import Loader from '../../components/Loader'
import { usePrimarySales } from '../../hooks/Sales/usePrimarySales'
import AddPrimarySales from './AddPrimarySales'

export default function EditPrimarySales() {
  const { primarySales, getPrimarySales } = usePrimarySales()
  const params = useParams()
  useEffect(() => {
    getPrimarySales({ primarySalesId: params.primarySalesId })
  }, [params.salesId])

  return <> {primarySales ? <AddPrimarySales primarySales={primarySales} /> : <Loader />} </>
}
